import { AuditReportsPublicJobDto } from '@mi-front/api-v2';
import { FormattedMessage } from 'react-intl';
import { JobProgress } from '../../../../../../../components/base/JobProgress';
import { SavedReportListItem } from '../types';

interface Props {
  item: SavedReportListItem;
}

/**
 * Shows generation or export status for a saved report list row.
 */
export function ReportListStatus({ item }: Props) {
  if (item.job) {
    return <JobProgress job={item.job as AuditReportsPublicJobDto} size="small" />;
  }

  if (item.gipExportStatus) {
    return (
      <JobProgress
        job={
          {
            status: item.gipExportStatus,
          } as AuditReportsPublicJobDto
        }
        size="small"
      />
    );
  }

  if (item.type === 'AUDIT_BROADCAST_EVIDENCE') {
    return (
      <FormattedMessage id="audit.reportsList.noExport" defaultMessage="No exportado">
        {(txt) => <span className="text-muted">{txt}</span>}
      </FormattedMessage>
    );
  }

  if (item.type === 'AUDIT_GIP_STATUS' || item.type === 'AUDIT_GIP_ALTERNATIVE_REPORT') {
    return (
      <FormattedMessage id="audit.reportsList.noExport" defaultMessage="No exportado">
        {(txt) => <span className="text-muted">{txt}</span>}
      </FormattedMessage>
    );
  }

  return null;
}
